import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import api from '~/services/api';
import history from '~/services/history';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Select from '~/components/Form/Select';
import Load from '~/components/Load';

import { Container } from './styles';

export default function TimesNew() {
  const inputRef = useRef(null);
  const user = useSelector(state => state.user.profile);
  const [cidade, setCidade] = useState([]);
  const [carregar, setCarregar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [incorporadoras, setIncorporadoras] = useState([]);

  useEffect(() => {
    async function getCidades() {
      setLoading(true);
      const response = await api.get('/cidades');

      const data = response.data.map(ci => ({
        value: ci.id,
        label: ci.name,
      }));

      if (user.provider === '4') {
        const inc = await api.get('/incorporadora');
        const dat = inc.data.map(ic => ({
          value: ic.id,
          label: ic.name,
        }));
        setIncorporadoras(dat);
      }
      setCidade(data);
      setLoading(false);
    }
    getCidades();
  }, [user.provider]);

  const dataTemplate = [
    {
      value: 1,
      label: 'Sim',
    },
    {
      value: 2,
      label: 'Não',
    },
  ];

  const modeloTemplate = [
    {
      value: 1,
      label: 'Aleatorio',
    },
    {
      value: 2,
      label: 'Horario de trabalho do sdr',
    },
  ];

  /**
   * Funcoes
   */
  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      let schema;

      if (user.provider !== '4') {
        schema = Yup.object().shape({
          name: Yup.string().required('Preencha o campo nome'),
          cidade_id: Yup.string('Selecione uma cidade').required(
            'Selecione uma cidade'
          ),
          incorporadora_id: Yup.string('Selecione a incorporadora').required(
            'Selecione a incorporadora'
          ),
          telefone: Yup.string().required('Preencha o campo telefone'),
          email: Yup.string().email('Informe um email válido'),
          token: Yup.string().required('Preencha o campo token (Mercury)'),
          instance_number: Yup.string().required(
            'Preencha o campo instance number (Mercury)'
          ),
          hora_abertura: Yup.string().required(
            'Preencha o campo hora de abertura'
          ),
          hora_encerramento: Yup.string().required(
            'Preencha o campo hora de encerramento'
          ),
          atende_sabado: Yup.string('Selecione se atende no sabado').required(
            'Selecione se atende no sabado'
          ),
          atende_domingo: Yup.string('Selecione se atende no domingo').required(
            'Selecione se atende no domingo'
          ),
          token_voice: Yup.string().required(
            'Preencha o campo token (Total Voice)'
          ),
          id_ramal: Yup.string().required(
            'Preencha o campo id ramal (Total Voice)'
          ),
          ramal: Yup.string().required('Preencha o campo ramal (Total Voice)'),
          numero_atendimento: Yup.string().required(
            'Preencha o campo numero de atendimento'
          ),
          modelo_atendimento: Yup.string(
            'Selecione o modelo de atendimento'
          ).required('Selecione o modelo de atendimento'),
          temperatura: Yup.string(
            'Selecione se irá trabalhar com sistema de temperatura'
          ).required('Selecione se irá trabalhar com sistema de temperatura'),
          corretores: Yup.string(
            'Selecione se irá trabalhar com sistema de corretores'
          ).required('Selecione se irá trabalhar com sistema de corretores'),
        });
      } else {
        schema = Yup.object().shape({
          name: Yup.string().required('Preencha o campo nome'),
          cidade_id: Yup.string('Selecione uma cidade').required(
            'Selecione uma cidade'
          ),
          telefone: Yup.string()
            .required('Preencha o campo telefone')
            .min(10, 'Minimo de 10 numeros')
            .max(11, 'Maximo de 11 numeros'),
          email: Yup.string().email('Informe um email válido'),
          token: Yup.string().required('Preencha o campo token (Mercury)'),
          instance_number: Yup.string().required(
            'Preencha o campo instance number (Mercury)'
          ),
          hora_abertura: Yup.string().required(
            'Preencha o campo hora de abertura'
          ),
          hora_encerramento: Yup.string().required(
            'Preencha o campo hora de encerramento'
          ),
          atende_sabado: Yup.string('Selecione se atende no sabado').required(
            'Selecione se atende no sabado'
          ),
          atende_domingo: Yup.string('Selecione se atende no domingo').required(
            'Selecione se atende no domingo'
          ),
          token_voice: Yup.string().required(
            'Preencha o campo token (Total Voice)'
          ),
          id_ramal: Yup.string().required(
            'Preencha o campo id ramal (Total Voice)'
          ),
          ramal: Yup.string().required('Preencha o campo ramal (Total Voice)'),
          numero_atendimento: Yup.string().required(
            'Preencha o campo numero de atendimento'
          ),
          modelo_atendimento: Yup.string(
            'Selecione o modelo de atendimento'
          ).required('Selecione o modelo de atendimento'),
          temperatura: Yup.string(
            'Selecione se irá trabalhar com sistema de temperatura'
          ).required('Selecione se irá trabalhar com sistema de temperatura'),
          corretores: Yup.string(
            'Selecione se irá trabalhar com sistema de corretores'
          ).required('Selecione se irá trabalhar com sistema de corretores'),
        });
      }
      await schema.validate(data, {
        abortEarly: false,
      });

      if (user.provider === '4') {
        await api.post(`/incorporadora/${data.incorporadora_id}/time`, {
          cidade_id: data.cidade_id,
          atende_sabado: data.atende_sabado,
          atende_domingo: data.atende_domingo,
          modelo_atendimento: data.modelo_atendimento,
          temperatura: data.temperatura,
          name: data.name,
          telefone: data.telefone,
          email: data.email,
          token: data.token,
          instance_number: data.instance_number,
          hora_abertura: data.hora_abertura,
          hora_encerramento: data.hora_encerramento,
          token_voice: data.token_voice,
          id_ramal: data.id_ramal,
          ramal: data.ramal,
          numero_atendimento: data.numero_atendimento,
          corretores: data.corretores,
        });
      } else {
        await api.post(`/incorporadora/${user.time.incorporadora_id}/time`, {
          cidade_id: data.cidade_id,
          atende_sabado: data.atende_sabado,
          atende_domingo: data.atende_domingo,
          modelo_atendimento: data.modelo_atendimento,
          temperatura: data.temperatura,
          name: data.name,
          telefone: data.telefone,
          email: data.email,
          token: data.token,
          instance_number: data.instance_number,
          hora_abertura: data.hora_abertura,
          hora_encerramento: data.hora_encerramento,
          token_voice: data.token_voice,
          id_ramal: data.id_ramal,
          ramal: data.ramal,
          numero_atendimento: data.numero_atendimento,
          corretores: data.corretores,
        });
      }

      toast.success('Time cadastrado com sucesso');
      history.push('/times');
    } catch (err) {
      console.log('ERRROOOOO', err)
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar o time, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Cadastrar Time</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Input icon="MdBusiness" label="Nome" name="name" type="text" />
          {user.provider === '4' && (
            <Select
              name="incorporadora_id"
              labelSelect="Incorporadora"
              options={incorporadoras}
            />
          )}
          <Select name="cidade_id" labelSelect="Cidade" options={cidade} />
          <Input
            icon="MdPhone"
            label="Telefone"
            name="telefone"
            type="number"
          />
          <Input
            icon="MdPhone"
            label="Numero de atendimento"
            name="numero_atendimento"
            type="text"
          />
          <Input
            icon="MdEmail"
            label="Email"
            name="email"
            type="text"
          />
          <Input
            icon="MdChat"
            label="Token (ZapBox)"
            name="token"
            type="text"
          />
          <Input
            icon="MdChat"
            label="Url de atendimento (ZapBox)"
            name="instance_number"
            type="text"
          />
          <Input
            icon="MdHeadset"
            label="Token (Total Voice)"
            name="token_voice"
            type="text"
          />
          <Input
            icon="MdHeadset"
            label="Id ramal (Total Voice)"
            name="id_ramal"
            type="text"
          />
          <Input
            icon="MdKeyboardVoice"
            label="Ramal (Total Voice)"
            name="ramal"
            type="text"
          />
          <Input
            icon="MdTimer"
            label="Hora de abertura"
            name="hora_abertura"
            type="time"
          />
          <Input
            icon="MdTimer"
            label="Hora de encerramento"
            name="hora_encerramento"
            type="time"
          />
          <Select
            name="atende_sabado"
            labelSelect="Atende no sabado"
            options={dataTemplate}
          />
          <Select
            name="atende_domingo"
            labelSelect="Atende no domingo"
            options={dataTemplate}
          />
          <Select
            name="modelo_atendimento"
            labelSelect="Modelo de atendimento"
            options={modeloTemplate}
          />

          <Select
            name="temperatura"
            labelSelect="Irá trabalhar com sistema de temperatura"
            options={dataTemplate}
          />

          <Select
            name="corretores"
            labelSelect="Irá trabalhar com sistema de corretores"
            options={dataTemplate}
          />

          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
